import React from 'react'

const ShotListNoSceneState = () => {
    return (
        <div className="flex h-full w-full justify-center items-center text-muted-foreground">
            <p>Select a scene from the sidebar to view or create a shot list.</p>
        </div>
    )
}

export default ShotListNoSceneState
